import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import '../assets/css/drawer.css';
import '../assets/css/styles.css';
import Drawer from '../components/drawer.jsx'
import Modal from '../components/modal.jsx'
import Progress from '../components/progress.jsx'
import Card from '../components/card.jsx'
import Categoria from '../components/categoria.jsx'
import logo from '../assets/img/logo.png';
import { getApi } from '../funciones/sesion.js';

function Carta(props) {

    const [titulo, setTitulo] = useState("-")
    const [precio, setPrecio] = useState("-")
    const [puntos, setPuntos] = useState("-")
    const [descripcion, setDescripcion] = useState("-")
    const [foto, setFoto] = useState("-")

    function mostrarMas(id) {

        const btn = document.getElementsByName("btn" + id);
        const parent = document.getElementById("cat" + id);
        const child = parent.querySelectorAll('.row-card');
        let bandera = child[0].classList[1] == "visible" ? "1" : "0";

        if (bandera == "0") {
            btn[0].innerText = "Ver menos"
        } else {
            btn[0].innerText = "Ver más"
        }
        child.forEach((element) => {
            element.classList.toggle("visible")
        });


    }

    function getCarta() {
        createRoot(document.getElementById("dg")).render(<Progress />)


        getApi("escoba_getMenu/").then(data => {

            const cat = data.json_categoria
                .filter((a, b) => a.titulo != "Extras")
                .slice()
                .sort((a, b) => a.titulo.localeCompare(b.titulo))
                .map((element, index) => (
                    <div id={"cat" + index} class="categoria">
                        <div><div class="titulo btn-cat"><small>{element.titulo}</small></div></div>
                        <div id={"idx" + index} class="end"><div id={index} name={"btn" + index} class="expand btn-cat" onClick={(e) => mostrarMas(e.target.id)}>Ver más</div></div>
                        {element.subitems
                            .filter((subelement) => subelement.status == "A")
                            .slice()
                            .sort((a, b) => a.nombre.localeCompare(b.nombre)).map((subelement, subindex) => (
                                <Card
                                    rwid={subelement.id}
                                    key={subindex}
                                    Descripcion={subelement.nombre}
                                    Precio={subelement.precio}
                                    Prev={"data:image/png;base64," + subelement.image}
                                />

                            ))}
                    </div>
                ));

            createRoot(document.getElementById("carta")).render(
                <div className="cards-container">
                    {cat}
                </div>
            );
            createRoot(document.getElementById("dg")).unmount(<Progress />)
        });
    }

    function getProducto(id) {
        const body = document.getElementById("container");

        body.classList.add('no-scroll');


        createRoot(document.getElementById("dg")).render(<Progress />)
        getApi("escoba_getProducto/" + id).then(data => {
            setTitulo(data.nombre)
            setPrecio(data.precio)
            setPuntos(data.puntos)
            setFoto(data.imagen)
            setDescripcion(data.descripcion)
            document.getElementById("modal").classList.add("view-modal")
            document.getElementById("modal").classList.toggle("view-modal-no")
            createRoot(document.getElementById("dg")).unmount(<Progress />)
        });
    }



    useEffect(() => {
        const elements = document.getElementsByClassName('element');
        

        createRoot(document.getElementById("dg")).render(<Progress />)
        // Using Array.from() and forEach
        document.addEventListener('click', (event) => {
            if (event.target.classList.contains('row-card')) {
                getProducto(event.target.getAttribute("name"));

            }
        });
        document.addEventListener('click', (event) => {
            if (event.target.classList.contains('end')) {
                let id = event.target.id;
                mostrarMas(id.replace("idx", ""))
            }
        });
        getCarta();
    }, []);
    return (
        <div className="Sesion">
            <header>

            </header>
            {<Modal
                titulo={titulo}
                precio={precio}
                puntos={puntos}
                descripcion={descripcion}
                foto={foto}
            ></Modal>}
            
            <div id="dg"></div>
            <div id="container" class="container-">
                <div class="drawer-header-" style={{marginTop:0}}>
                    <div style={{ height: 250, zIndex: 50, position: "relative", justifyContent: "center" }} class="center-v-">
                        La Escoba Encantada<br></br>
                        <label style={{ textAlign: "center" }}>    Una cafetería para los amantes del universo de<br></br>
                            Harry Potter<br></br></label>
                    </div>
                </div>

                <div id="carta">

                </div>


            </div>



        </div>);
}

export default Carta;